





























































import Vue from "vue";
import {
  getIPRestriction,
  saveIPRestriction,
} from "@/services/IP-restriction/IP-restriction";
export default Vue.extend({
  data: () => ({
    loading: false,
    checkbox: false,
    IPArr: [""],
    textError: "",
    showError: false,
  }),
  mounted() {
    this.getDataIPRestriction();
  },
  computed: {
    form(): Vue & { validate: () => boolean } {
      return this.$refs.form as Vue & { validate: () => boolean };
    },
  },
  methods: {
    addValue() {
      this.IPArr.push("");
    },
    delValue(key: number) {
      this.IPArr.splice(key, 1);
    },
    isValidIP(value: string) {
      if (value.length == 0) {
        return "Campo requerido";
      }
      if (
        !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          value
        )
      ) {
        return "IP no válida";
      }
      return !!value || "Campo requerido";
    },
    async saveData() {
      if (this.form.validate()) {
        const dataJSON = {
          enabled: this.checkbox,
          list: this.checkbox ? this.IPArr : null,
        };
        this.loading = true;
        await saveIPRestriction(dataJSON)
          .then(() => {
            this.$router.push("/customers");
          })
          .catch((e) => {
            this.textError = e;
            this.showError = true;
          });
        this.loading = false;
      }
    },
    async getDataIPRestriction() {
      this.loading = true;
      await getIPRestriction()
        .then((res) => {
          if (res.enabled) {
            this.checkbox = true;
            this.IPArr = res.list == null ? [""] : res.list;
          }
        })
        .catch((e) => {
          this.textError = e;
          this.showError = true;
        });
      this.loading = false;
    },
  },
});
